import React from "react";
import Button from "../Button";
// import { gtag_report_conversion } from "analytics";

const SlideInfo = () => {
  return (
    <div className="home-slider__info-container">
      <hr className="home-slider_info__line"/>
      <h4 className="home-slider_info">Ventas al 0800.333.2582</h4>

      <h1 className="home-slider_title">Alta Salud: Cobertura médica de calidad.</h1>
      <hr className="home-slider_info__line"/>

      <h4 className="home-slider_info">
        ¿Aún no sos
        socio?
      </h4>
      <Button url="/contacto" type="slideinfo" style={{marginTop:'20px', fontSize:'26px !important'}} external={false}
      onClick={() => {
        window.gtag('event', 'conversion', {
          'send_to': 'AW-622659677/IfKXCOjcmoUZEN2Q9KgC',
          'value': 1.0,
          'currency': 'ARS'
        });
        
      }}>
        Asociarme
      </Button>
      
    </div>
    
  );
};




export default SlideInfo;